const map = {
	"./en/10weeks.png": 7208,
	"./en/14weeks.png": 100,
	"./en/18months.png": 1794,
	"./en/24months.png": 3967,
	"./en/6&7months.png": 7768,
	"./en/6weeks.png": 8737,
	"./en/9months.png": 4997,
	"./en/girls10years.png": 9808,
	"./en/newborn.png": 1789,
	"./en/pregnant.png": 3299,
	"./sw/10weeks.png": 2179,
	"./sw/14weeks.png": 663,
	"./sw/18months.png": 7463,
	"./sw/24months.png": 4474,
	"./sw/6&7months.png": 9839,
	"./sw/6weeks.png": 8912,
	"./sw/9months.png": 9465,
	"./sw/girls10years.png": 8269,
	"./sw/newborn.png": 2106,
	"./sw/pregnant.png": 6734
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9940;